import React from 'react';
import { getHighlightedTitleSegments } from './HighlightedTitle.helpers';

type HighlightedTitleProps = {
  title: string;
  filter?: string;
};

export const HighlightedTitle = ({ title, filter }: HighlightedTitleProps) => {
  const segments = filter ? getHighlightedTitleSegments(title, filter) : null;

  if (!segments) {
    return title;
  }

  return (
    <>
      {segments.map((segment, index) =>
        segment.highlighted ? (
          <mark key={index}>{segment.text}</mark>
        ) : (
          segment.text
        )
      )}
    </>
  );
};
